<div popper [validate]="formControl">
  <daterange-picker [disabled]="disabled"
                    [ngModel]="value"
                    (ngModelChange)="change($event)"
                    [clearable]="true"
                    [single]="single"
                    [default]="default"
                    [placeholder]="placeholder">
  </daterange-picker>
</div>
